import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/i18n/site";
import { AppLayout } from "@/components/AppLayout";

import Home from "@/pages/public/Home";
import Login from "@/pages/Login";

import Dashboard from "@/pages/erp/Dashboard";
import Clients from "@/pages/erp/Clients";
import Products from "@/pages/erp/Products";
import Suppliers from "@/pages/erp/Suppliers";
import Quotations from "@/pages/erp/Quotations";
import QuotationEditor from "@/pages/erp/QuotationEditor";
import Orders from "@/pages/erp/Orders";
import OrderDetail from "@/pages/erp/OrderDetail";
import Invoices from "@/pages/erp/Invoices";
import Billing from "@/pages/erp/Billing";
import Cobranza from "@/pages/erp/Cobranza";
import CotizacionesWeb from "@/pages/erp/CotizacionesWeb";
import Pipeline from "@/pages/erp/Pipeline";
import Campaigns from "@/pages/erp/Campaigns";
import Plantillas from "@/pages/erp/Plantillas";
import UsersPage from "@/pages/erp/Users";
import Audit from "@/pages/erp/Audit";
import Settings from "@/pages/erp/Settings";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <div className="min-h-screen grid place-items-center text-muted-foreground">Cargando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <AppLayout>{children}</AppLayout>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<LanguageProvider><Home /></LanguageProvider>} />
            <Route path="/nosotros" element={<Navigate to="/" replace />} />
            <Route path="/servicios" element={<Navigate to="/" replace />} />
            <Route path="/contacto" element={<Navigate to="/" replace />} />
            <Route path="/login" element={<Login />} />

            <Route path="/app" element={<Protected><Dashboard /></Protected>} />
            <Route path="/app/pipeline" element={<Protected><Pipeline /></Protected>} />
            <Route path="/app/clientes" element={<Protected><Clients /></Protected>} />
            <Route path="/app/productos" element={<Protected><Products /></Protected>} />
            <Route path="/app/cotizaciones" element={<Protected><Quotations /></Protected>} />
            <Route path="/app/cotizaciones-web" element={<Protected><CotizacionesWeb /></Protected>} />
            <Route path="/app/cotizaciones/:id" element={<Protected><QuotationEditor /></Protected>} />
            <Route path="/app/pedidos" element={<Protected><Orders /></Protected>} />
            <Route path="/app/pedidos/:id" element={<Protected><OrderDetail /></Protected>} />
            <Route path="/app/proveedores" element={<Protected><Suppliers /></Protected>} />
            <Route path="/app/facturas" element={<Protected><Invoices /></Protected>} />
            <Route path="/app/facturacion" element={<Protected><Billing /></Protected>} />
            <Route path="/app/cobranza" element={<Protected><Cobranza /></Protected>} />
            <Route path="/app/campanas" element={<Protected><Campaigns /></Protected>} />
            <Route path="/app/plantillas" element={<Protected><Plantillas /></Protected>} />
            <Route path="/app/usuarios" element={<Protected><UsersPage /></Protected>} />
            <Route path="/app/auditoria" element={<Protected><Audit /></Protected>} />
            <Route path="/app/ajustes" element={<Protected><Settings /></Protected>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
